const isDevEnvironment = (): boolean => {
  return process.env.NODE_ENV === 'development'
}

const getServerBaseUrl = (): string => {
  const localServerUrl: string =
    process.env.REACT_APP_LOCAL_SIGNALR_SERVER_URI ?? 'https://localhost:7246'
  return isDevEnvironment() ? localServerUrl : window.location.origin
}

export { getServerBaseUrl, isDevEnvironment }
